
const mutations = {
  SET_LOGIN (state, payload) {
    state.userdata = payload
  },
  SET_LOCALE(state, payload) {
    state.locale = payload;
  },
  SET_NOTIFICATION(state, payload) {
    state.notifications = payload.notifications;
    state.totalNotif = payload.total;
  }
}

export default mutations
  